export default "__VITE_ASSET__Gscvi2jO__"